import { render } from "./subComponentPrice.vue?vue&type=template&id=5735ed50"
import script from "./subComponentPrice.vue?vue&type=script&lang=js"
export * from "./subComponentPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__